"use client";

import type { PlainDate, PlainDateString } from "@sa-nu/shared-utils/date";

import type { BrowseArea } from "../../_hooks/use-room-type-search";
import type { SearchCalendarDateInfo } from "../../_utils/build-search-calendar-date-info-map";

import { AreaFilterPopup } from "./area-filter-popup";
import type { ApplyConditions } from "./condition-filter-popup";
import { ConditionFilterPopup } from "./condition-filter-popup";
import { DateFilterPopup } from "./date-filter-popup";

/**
 * PC サイドバーのフィルタ集約。エリア・滞在期間・絞り込み条件（建築タイプ/設備/Large/EV）
 * の各セクション。いずれも「ラベル＋トリガーフィールド＋適用チップ＋ポップアップ」形式。
 */
export function PcSidebar({
  areas,
  selectedAreaSlugs,
  onToggleArea,
  onApplyAreaSlugs,
  selectedFacilities,
  onToggleFacility,
  evChargerAvailable,
  onToggleEvCharger,
  selectedArchTypes,
  onToggleArchType,
  largeOnly,
  onToggleLargeOnly,
  onApplyConditions,
  firstNight,
  lastNight,
  onSetStayRange,
  onClearStayRange,
  dateInfoMap,
  dateInfoMapLoading,
}: {
  areas: BrowseArea[];
  selectedAreaSlugs: ReadonlySet<string>;
  onToggleArea: (slug: string) => void;
  /** 決定・セクションクリア時の一括適用（AreaFilterPopup から呼ばれる） */
  onApplyAreaSlugs: (slugs: string[]) => void;
  selectedFacilities: ReadonlySet<string>;
  onToggleFacility: (slug: string) => void;
  evChargerAvailable: boolean;
  onToggleEvCharger: () => void;
  selectedArchTypes: ReadonlySet<string>;
  onToggleArchType: (key: string) => void;
  largeOnly: boolean;
  onToggleLargeOnly: () => void;
  /** 絞り込み条件ポップアップ「決定」・セクションクリア時の4次元一括適用 */
  onApplyConditions: (conditions: ApplyConditions) => void;
  firstNight: PlainDate | null;
  lastNight: PlainDate | null;
  onSetStayRange: (firstNight: PlainDate, lastNight: PlainDate) => void;
  onClearStayRange: () => void;
  /** 日付ごとの最低価格・在庫状況。DateFilterPopup へそのまま中継する */
  dateInfoMap?: Record<PlainDateString, SearchCalendarDateInfo>;
  /** dateInfoMap 取得中かどうか。DateFilterPopup へそのまま中継する */
  dateInfoMapLoading?: boolean;
}) {
  return (
    <div className="flex flex-col gap-[24px] p-[16px] lg:p-[24px]">
      <AreaFilterPopup
        areas={areas}
        selectedAreaSlugs={selectedAreaSlugs}
        onToggleArea={onToggleArea}
        onApplyAreaSlugs={onApplyAreaSlugs}
      />
      <DateFilterPopup
        firstNight={firstNight}
        lastNight={lastNight}
        onConfirm={onSetStayRange}
        onClear={onClearStayRange}
        dateInfoMap={dateInfoMap}
        dateInfoMapLoading={dateInfoMapLoading}
      />
      <ConditionFilterPopup
        selectedArchTypes={selectedArchTypes}
        onToggleArchType={onToggleArchType}
        selectedFacilities={selectedFacilities}
        onToggleFacility={onToggleFacility}
        largeOnly={largeOnly}
        onToggleLargeOnly={onToggleLargeOnly}
        evChargerAvailable={evChargerAvailable}
        onToggleEvCharger={onToggleEvCharger}
        onApplyConditions={onApplyConditions}
      />
    </div>
  );
}
